(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyInfoV2Controller', CompanyInfoV2Controller);

    CompanyInfoV2Controller.$inject = ['$rootScope', '$state', '__config', '$timeout', '$scope', '$stateParams', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag', 'CompanyInfoQuery', 'Principal', 'CompanyCustom', 'ActivityTypeInfo', 'ActivityTypeInfoCustom'];

    function CompanyInfoV2Controller($rootScope, $state, __config, $timeout, $scope, $stateParams, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag, CompanyInfoQuery, Principal, CompanyCustom, ActivityTypeInfo, ActivityTypeInfoCustom) {
        var vm = this;
        vm.scope = $scope;
        vm.__config = __config;
        vm.isCompanyNameValid = isCompanyNameValid;
        vm.isUrlValid = true;
        //
        //vm.company = entity;
        vm.company = CompanyInfoQuery.getCurrentCompanyInfo().query();
        vm.clear = clear;
        vm.save = save;
        //vm.settinginfos = SettingInfo.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.locationinfos = LocationInfo.query();
        vm.metatags = MetaTag.query();
        vm.metatagOptions = {
            placeholder: "--",
            dataTextField: "tag",
            //dataValueField: "id",
            valuePrimitive: true,
            autoBind: false,
            dataSource: vm.metatags
        };

        vm.activityTypes = [];


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        $rootScope.$broadcast('hideNavBar');


        loadAllActivityTypes();

        // $timeout(function (){
        //     angular.element('.form-group:eq(1)>input').focus();
        // });

        function clear() {

        }

        function save() {

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;
                if (vm.company.id !== null) {
                    Company.update(vm.company, onSaveSuccess, onSaveError);
                } else {
                    //Company.save(vm.company, onSaveSuccess, onSaveError);
                }
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyUpdate', result);

            if (result)
                Principal.setCurrentCompany(result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function isCompanyNameValid() {
            vm.isUrlValid = field_keyUrl.checkValidity();
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

        function loadAllActivityTypes() {
            ActivityTypeInfoCustom.getAllActivityTypeInfos().query(function (result) {
                vm.activityTypes = result;
                categorizeActivityTypes();
            });
        }

        function categorizeActivityTypes() {

            vm.typeCategories = [];

            vm.beauty = {};
            vm.beauty.title = 'زیبایی';
            vm.beauty.items = [];

            vm.health = [];
            vm.health.title = 'سلامتی';
            vm.health.items = [];

            vm.serviceBase = [];
            vm.serviceBase.title = 'خدماتی';
            vm.serviceBase.items = [];

            vm.education = [];
            vm.education.title = 'آموزشی';
            vm.education.items = [];

            vm.entertainment = [];
            vm.entertainment.title = 'تفریحی ورزشی';
            vm.entertainment.items = [];

            vm.enterprise = [];
            vm.enterprise.title = 'سازمان و شرکت';
            vm.enterprise.items = [];

            if (vm.activityTypes) {
                angular.forEach(vm.activityTypes, function (item) {

                    switch (item.category) {
                        case 'BEAUTY' :
                            vm.beauty.items.push(item);
                            break;
                        case 'HEALTH' :
                            vm.health.items.push(item);
                            break;
                        case 'EDUCATION' :
                            vm.education.items.push(item);
                            break;
                        case 'ENTERTAINMENT' :
                            vm.entertainment.items.push(item);
                            break;
                        case 'SERVICE_BASE' :
                            vm.serviceBase.items.push(item);
                            break;
                        case 'ENTERPRISE' :
                            vm.enterprise.items.push(item);
                            break;

                    }
                })

                vm.typeCategories.push(vm.beauty);
                vm.typeCategories.push(vm.health);
                vm.typeCategories.push(vm.serviceBase);
                vm.typeCategories.push(vm.education);
                vm.typeCategories.push(vm.enterprise);
                vm.typeCategories.push(vm.entertainment);


            }
        }
    }
})();
